import React from 'react';
import cn from 'classnames';
import { bbCodeToHtml } from '../../../../../../../utils/formUtils';
import { Visibility } from '../../../../../../../types/common-types';
import './style.scss';

enum Align {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

interface Props {
  id?: string;
  value: string;
  align: Align;
  style?: object;
  extra?: {
    sectionTitle?: boolean;
  };
  visibility: Visibility;
  onSubmit: (id: string) => void;
}

const LabelBF: React.FC<Props> = ({
  id,
  visibility,
  align,
  value,
  style,
  extra = {},
}) => {
  return (
    <div
      id={id}
      style={style}
      data-cy="label"
      className="labelbf"
      styleName={cn('label', {
        hidden: visibility === Visibility.Hidden,
        left: align === Align.Left,
        center: align === Align.Center,
        right: align === Align.Right,
      })}
    >
      {extra.sectionTitle ? (
        <section style={style}>
          <h3
            style={{ padding: '0px 0px 0px 15px' }}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: bbCodeToHtml(value),
            }}
          />
        </section>
      ) : (
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: bbCodeToHtml(value),
          }}
        />
      )}
    </div>
  );
};
export default LabelBF;
